module.exports = __webpack_public_path__ + "media/images/orion_pictos/help-e517f0f1a56ddff1840ee45e7b90be07.svg";